export const accountsReceivableRouting = [
  {
    path: "/report-center/download/project-receivable/list",
    name: "download-project-receivable-list",
    meta: { title: "应收账单", comName: "projectReceivableList" },
    component: () =>
      import(
        /* webpackChunkName: "labor-wage" */ "@/views/report-center/project-receivable/list/index.vue"
      ),
  },
];
